exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-box[data-v-1e87df0d]{min-height:620px}[data-v-1e87df0d] .fc-files{width:752px;height:90px}\n", ""]);

// exports
